<template>
  <div 
    class="input-asset" 
    :class="{
      'input-asset--disabled': disabled,
      'input-asset--multiple': multiple,
      'input-asset--dropzone': isDraggingAsset
    }"
    @dragover.prevent.stop="dragAsset"
    @dragleave.prevent.stop="isDraggingAsset = false"
    @drop.prevent.stop="dropAsset"
  >
    <draggable v-if="multiple" v-model="libraryModel" @start="drag = true" @end="drag = false" :group="group" style="max-height: 320px; overflow: auto;">
      <div v-for="asset in libraryModel" class="input-asset__asset" :key="asset.path">
        <div class="input-asset__thumb-wrapper">
          <img
            class="input-asset__thumb"
            :src="asset.type === 'pdf' ? require('../assets/img/pdf-thumb.jpg') : $store.state.assetsPath + asset.thumbPath"
          >
        </div>
        <div class="input-asset__details">
          <div class="input-asset__description">{{ asset.description.length ? asset.description : 'No Description' }}</div>
          <div class="input-asset__path">{{ asset.path }}</div>
        </div>
        <div class="input-asset__remove">
          <button class="btn btn-sm btn-outline-danger" @click="quickRemoveAsset(asset)"><fa :icon="['fas', 'trash']" /></button>
        </div>
      </div>
    </draggable>    
    <div v-else-if="libraryModel && libraryModel.path.length">
      <div class="input-asset__asset">
        <div class="input-asset__thumb-wrapper">
          <img
            class="input-asset__thumb"
            :src="$store.state.assetsPath + libraryModel.thumbPath"
          >
        </div>
        <div class="input-asset__details">
          <div class="input-asset__description">{{ libraryModel.description.length ? libraryModel.description : 'No Description' }}</div>
          <div class="input-asset__path">{{ libraryModel.path }}</div>
        </div>
        <div class="input-asset__remove">
          <button class="btn btn-sm btn-outline-danger" @click="removeAsset"><fa :icon="['fas', 'trash']" /></button>
        </div>
      </div>
    </div>
    <div class="input-asset__actions">
      <button class="input-asset__add" v-if="!disabled" @click="openAssetLibrary"><fa :icon="['fa', 'plus']"/>Add an asset</button>
    </div>
    <asset-library
      v-if="isLibraryVisible"
      v-model="libraryModel"
      :multiple="multiple"
      :defaultCategory="defaultCategory ? defaultCategory : ''"
      @close="closeAssetLibrary"
    ></asset-library>
  </div>
</template>
<script>
import _ from 'lodash'
import AssetLibrary from '@/components/NewAssetLibrary'
import Draggable from 'vuedraggable'

export default {
  components: { AssetLibrary, Draggable },

  props: ['disabled', 'value', 'required-dimensions', 'multiple', 'defaultCategory', 'requirements', 'returnid', 'group'],

  data () {
    return {
      isLibraryVisible: false,
      libraryModel: null,

      isDraggingAsset: false,
      isUploading: false
    }
  },


  computed: {
    assets () {
      return this.$store.state.assetLibrary.assets
    },
  },

  mounted () {
    this.initLibraryModel()
  },

  watch: {
    libraryModel () {
      if (this.libraryModel) {
        if (this.multiple) {
          if (this.returnid) {
            const value = this.libraryModel.map(asset => {
              return asset._id
            })
            this.$emit('input', _.uniq(value))
          } else {
            const value = this.libraryModel.map(asset => {
              return asset.path
            })
            this.$emit('input', _.uniq(value))
          }
        } else {
          if (this.returnid) {
            this.$emit('input', this.libraryModel._id)
          } else {
            this.$emit('input', this.libraryModel.path)
          }
        }
      }
    },

    assets () {
      this.initLibraryModel()
    },

    value () {
      if (this.libraryModel) {
        if (this.multiple) {
          if (this.returnid) {
            const libraryModelIds = JSON.stringify(this.libraryModel.map(asset => {
              return asset._id
            }))
            const valueIds = JSON.stringify(this.value)
            if (libraryModelIds !== valueIds) {
              this.initLibraryModel()
            }
          } else {
            const libraryModelPaths = JSON.stringify(this.libraryModel.map(asset => {
              return asset.path
            }))
            const valuePaths = JSON.stringify(this.value)
            if (libraryModelPaths !== valuePaths) {
              this.initLibraryModel()
            }
          }
        } else {
          if (this.returnid) {
            if (this.value !== this.libraryModel._id) {
              this.initLibraryModel()
            }
          } else {
            if (this.value !== this.libraryModel.path) {
              this.initLibraryModel()
            }
          }
        }
      } else {
        this.initLibraryModel()
      }
    }
  },

  methods: {
    closeAssetLibrary () {
      this.isLibraryVisible = false
    },

    openAssetLibrary () {
      if (!this.disabled) {
        this.isLibraryVisible = true
      }
    },

    initLibraryModel () {
      if (this.assets.length) {        
        if (this.multiple) {
          let libraryModel = []

          if (this.returnid) {
            this.value.forEach(id => {
              libraryModel.push(_.find(this.assets, asset => {
                return asset._id === id
              }))
            })
          } else {
            this.value.forEach(path => {
              libraryModel.push(_.find(this.assets, asset => {
                return asset.path === path
              }))
            })
          }
          
          this.libraryModel = libraryModel
        } else {
          if (this.returnid) {
            this.libraryModel = null

            if (this.value) {
              this.libraryModel = _.find(this.assets, asset => {
                return asset._id === this.value
              })
            } else {
              this.libraryModel = null
            }
          } else {
            this.libraryModel = _.find(this.assets, asset => {
              return asset.path === this.value
            })
          }
        }
      }
    },

    quickRemoveAsset (asset) {
      this.libraryModel = _.remove(this.libraryModel, libAsset => {
        return libAsset._id !== asset._id
      })
    },

    removeAsset () {
      if (this.multiple) {
        this.$emit('input', [])
      } else {
        if (this.returnid) {
          this.$emit('input', null)
        } else {
          this.$emit('input', '')
        }
      }
    },

    dragAsset (e) {
      this.isDraggingAsset = true
    },

    dropAsset (e) {
      this.isDraggingAsset = false

      if (e.dataTransfer.files.length) {
        this.createAsset(e.dataTransfer.files)
      }
    },

    createAsset (files) {
      this.isUploading = true

      if (files.length > 1) {
        for (var i = 0; i < files.length; i++) {
          this.$store.dispatch('UPLOAD_ASSET', {
            category: this.defaultCategory ? this.defaultCategory : 'misc',
            description: files[i].name,
            file: files[i]
          }).then(asset => {
            this.isUploading = false

            this.attachAsset(asset)
          }).catch(err => {
            this.isUploading = false
            console.log('error', err)
          })
        }
      } else {
        this.$store.dispatch('UPLOAD_ASSET', {
          category: this.defaultCategory ? this.defaultCategory : 'misc',
          description: this.assetDescription ? this.assetDescription : files[0].name,
          file: files[0]
        }).then(asset => {
          this.isUploading = false

          this.attachAsset(asset)
        }).catch(err => {
          this.isUploading = false
          console.log('error', err)
        })
      }
    },

    async attachAsset (asset) {
      await this.$store.dispatch('FETCH_ASSETS')
      let newValue = this.value

      if (this.multiple) {
        newValue.push(this.returnid ? asset._id : asset.path)
      } else {
        newValue = this.returnid ? asset._id : asset.path
      }

      this.$emit('input', newValue)
    }
  }
}
</script>
<style lang="scss">
  .input-asset {
    border-radius: 3px;
    border: 1px solid rgba(96, 125, 159, 0.25);
    background-color: #fbfcfe;
    box-shadow: inset 0 1px 4px -1px rgba(96, 125, 159, 0.25);
    background-clip: padding-box;
    padding: 7px;
    width: 100%;

    &--multiple {
      .input-asset__asset {
        cursor: grab;

        &:hover {
          background-color: #cbd5e0;
        }
      }
    }

    &--dropzone {
      outline: 4px solid #2079ed;
    }

    &__col {
      width: 50%;
    }

    &__asset {
      align-items: center;
      display: flex;
      margin-bottom: 7px;
      width: 100%;
    }

    &__thumb-wrapper {
      background-image: 
        linear-gradient(to right, rgba(230, 237, 245, 0.85), rgba(230, 237, 245, 0.85)), 
        linear-gradient(to right, #000 50%, #fff 50%), 
        linear-gradient(to bottom, #000 50%, #fff 50%);
      background-blend-mode: normal, difference, normal;
      background-size: 1em 1em;
      display: flex;
      width: 100px;
    }

    &__thumb {
      border-radius: 3px;
      overflow: hidden;
      object-fit: contain;
      flex-shrink: 0;
      width: 100%;

      .input-asset--disabled & {
        cursor: default;
      }
    }

    &__details {
      padding-left: 7px;
      width: 100%;
      word-break: break-all;
    }
    
    &__path {
      opacity: 0.5;
      font-size: 0.8em;
    }

    &__add {
      background-color: transparent;
      border: 1px dashed #ccc;
      border-radius: 16px;
      width: auto;
      padding: 0.5em 1em;

      svg {
        margin-right: 0.5em;
      }
    }

    &__remove {
      align-self: center;
      margin-right: 8px;
    }
  }
</style>